import styled from 'styled-components';

export const StyledSpan = styled.span`
	background-color: ${({ backGroundColor }) => backGroundColor};
`;
